import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import I18nMarkdown from '../../Common/i18nMarkdown';

import cn from 'classnames';

import { map } from 'lodash-es';

import { fieldShape, selectionShape } from './index.shape';
import { addClassName } from './index.utils';

import './index.scss';

/**
 * Radio button
 * @param props
 * @returns {XML}
 * @constructor
 */
const InputRadio = ({
  nameGroup,
  disabled,
  id,
  value,
  label,
  valueSelected,
  showError,
  existError,
  handleChange,
  blockId,
}) => {
  const radioId = `${blockId}${nameGroup}${id}`;

  return (
    <span className="input-radio">
      <input
        className="input"
        name={nameGroup}
        id={radioId}
        type="radio"
        value={value}
        disabled={disabled}
        checked={valueSelected === value}
        onChange={() => handleChange(value)}
      />
      <label className={addClassName({ existError, showError, disabled })} htmlFor={radioId}>
        <I18nMarkdown string={label} defaultValue={label} />
      </label>
    </span>
  );
};

InputRadio.propTypes = {
  nameGroup: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  valueSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  blockId: PropTypes.string,
};

InputRadio.defaultProps = {
  valueSelected: undefined,
  disabled: false,
  blockId: '',
};

const RadioGroupCommon = ({
  field: { name, value },
  disabled,
  selection,
  existError,
  showError,
  nowrap,
  eventEmitter,
  blockId,
}) => {
  const [valueSelected, setValueSelected] = useState(value);

  const handleChangeLocal = id => {
    setValueSelected(id);
    eventEmitter(id);
  };

  // TODO ...
  // observable value
  useEffect(() => {
    setValueSelected(value);
  }, [value]);

  return (
    <div className={cn({ 'radio-button-group-24qsdfssfg4-00f8-4e7b-8825-dd064f4176a9': true, nowrap })}>
      {map(selection, (item, index) => (
        <InputRadio
          key={index}
          nameGroup={name}
          id={`${item.value}`}
          value={item.value}
          label={item.name}
          valueSelected={valueSelected}
          disabled={disabled}
          existError={existError}
          showError={showError}
          handleChange={v => handleChangeLocal(v)}
          blockId={blockId}
        />
      ))}
    </div>
  );
};

RadioGroupCommon.propTypes = {
  field: PropTypes.shape(fieldShape),
  selection: PropTypes.arrayOf(selectionShape).isRequired,
  disabled: PropTypes.bool,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  nowrap: PropTypes.bool,
  eventEmitter: PropTypes.func.isRequired,
  blockId: PropTypes.string,
};

RadioGroupCommon.defaultProps = {
  field: {
    value: undefined,
  },
  disabled: false,
  nowrap: false,
  blockId: '',
};

export default RadioGroupCommon;
